import { faLayerGroup, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LayerDropdownComponent from "./layer-dropdown.component";
import zoomIn from "../../../../../../../assets/images/zoom-in.png";
import zoomOut from "../../../../../../../assets/images/zoom-out.png";
import exitFullScreen from "../../../../../../../assets/images/arrows-collapse.png";
import fullScreen from "../../../../../../../assets/images/arrows-fullscreen.png";

interface CanvasControlsComponentProps {
  zoomLevel: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
  showLabels: boolean;
  onToggleLabels: (checked: boolean) => void;
  preventLabelOverlap: boolean;
  onToggleLabelOverlap: (checked: boolean) => void;
  showLayerDropdown: boolean;
  onToggleLayerDropdown: () => void;
  isFullscreen: boolean;
  onToggleFullscreen: () => void;
  onExitFullscreen: () => void;
  setZoomLevel: (z: number) => void;
  setContainerDimensions: (d: { height: number; width: number }) => void;
  setGlobalSelectedShape?: (s: any) => void;
}

const CanvasControlsComponent: React.FC<CanvasControlsComponentProps> = ({
  zoomLevel,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  showLabels,
  onToggleLabels,
  preventLabelOverlap,
  onToggleLabelOverlap,
  showLayerDropdown,
  onToggleLayerDropdown,
  isFullscreen,
  onToggleFullscreen,
  onExitFullscreen,
  setZoomLevel,
  setContainerDimensions,
  setGlobalSelectedShape,
}) => {
  return (
    <>
      <div
        className=""
        style={{
          paddingRight: "1rem",
          top: isFullscreen ? 200 : 20,
          position: "absolute",
          right: 0,
        }}

      >
        <div className="d-flex flex-col align-items-end">
          <div>
            <button
              type="button"
              className="cursor-pointer border-0 bg-transparent p-0 me-2 mb-3"
              style={{ width: "25px" }}
              onClick={onZoomIn}
              title="Zoom In"
              aria-label="Zoom In"
            >
              <img
                className="w-100"
                src={zoomIn}
                alt=""
              />
            </button>
          </div>

          <div>
            <button
              type="button"
              className="cursor-pointer border-0 bg-transparent p-0 me-2 mb-2"
              style={{ width: "25px" }}
              onClick={onZoomOut}
              title="Zoom Out"
              aria-label="Zoom Out"
            >
              <img
                className="w-100"
                src={zoomOut}
                alt=""
              />
            </button>
          </div>

          {zoomLevel !== 1 && (
            <div>
              <button
                className="btn pb-0 "
                style={{ marginRight: "0.2rem", padding: "0.5rem" }}
                onClick={onResetZoom}
                title="Reset Zoom"
              >
                <FontAwesomeIcon
                  icon={faRotateRight}
                  style={{ fontSize: "1.35rem" }}
                />
              </button>
            </div>
          )}
        </div>
      </div>

      <div
        className="flex justify-end w-100"
        style={{
          marginTop: isFullscreen
            ? "-24rem"
            : "-7rem",
          paddingRight: "1rem",
        }}
      >
        <div className="d-flex flex-col align-items-end gap-3">
          <div className="position-relative">
            <FontAwesomeIcon
              icon={faLayerGroup}
              className="cursor-pointer me-2 mb-1"
              style={{
                height: "25px",
                width: "25px",
                paddingRight: "1px",
              }}
              title="Layer Settings"
              onClick={onToggleLayerDropdown}
            />

            {showLayerDropdown && (
              <LayerDropdownComponent
                showLabels={showLabels}
                preventLabelOverlap={preventLabelOverlap}
                onToggleLabels={onToggleLabels}
                onToggleLabelOverlap={onToggleLabelOverlap}
              />
            )}
          </div>

          <div>
            {isFullscreen ? (
              <button
                type="button"
                className="cursor-pointer"
                style={{
                  marginRight: "10px",
                  marginBottom: "16px",
                  height: "22px",
                  width: "22px",
                  background: "none",
                  border: "none",
                  padding: 0,
                }}
                onClick={onExitFullscreen}
                title="Exit Full Screen"
              >
                <img
                  src={exitFullScreen}
                  alt="Exit Full Screen"
                  style={{
                    height: "22px",
                    width: "22px",
                  }}
                />
              </button>
            ) : (
              <button
                type="button"
                className="cursor-pointer"
                style={{
                  marginRight: "10px",
                  marginBottom: "16px",
                  height: "22px",
                  width: "22px",
                  background: "none",
                  border: "none",
                  padding: 0,
                }}
                onClick={() => {
                  onToggleFullscreen();
                  setZoomLevel?.(1.5);
                  setContainerDimensions?.({
                    height: window.innerHeight + 100,
                    width: window.innerWidth - 100,
                  });
                  setGlobalSelectedShape?.(null);
                }}
                title="View in Full Screen"
              >
                <img
                  src={fullScreen}
                  alt="Full Screen"
                  style={{
                    height: "22px",
                    width: "22px",
                  }}
                />
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default CanvasControlsComponent;
